import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import config from '../../../config';
import getBrowserInfo from '../../utils/getBrowserInfo';
import getDeviceType from '../../utils/getDeviceType';
import getOrCreateDeviceIdentity from '../../utils/getOrCreateDeviceKey';
import { editUser, editPublisher } from '../../actions';
import {
  setAuthToken,
  setRefreshToken,
  setDeviceIdentity,
  removeAuthToken,
  removeRefreshToken,
  removeDeviceIdentity
} from '../../utils/auth';
import { setItem, getItem } from '../../utils/localStorageFn';

// send Post data to fewcents db
async function createArticles(history) {
  const userData = JSON.parse(getItem('userdata'));
  const { accessToken } = userData;
  const userId = userData.user.id;
  const publisherData = JSON.parse(getItem('publisherdata'));
  const publisherId = publisherData.id;
  const postsData = JSON.parse(getItem('postsdata'));

  const body = JSON.stringify({
    articleList: postsData,
    publisherId,
    userId
  });

  const requestOptions = {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body
  };

  try {
    // eslint-disable-next-line no-unused-vars
    const response = await fetch(`${config.ApiBaseUrl}/wordpress/createArticles`, requestOptions);

    // const response_parsed = await response.json();
    // console.log(response_parsed);
    console.log('test:', history);
    history.push('/content');
  } catch (e) {
    console.log(e);
  }
}

async function retrievePosts(history) {
  const userData = JSON.parse(getItem('userdata'));
  const authorName = userData.user.name;
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    jQuery(document).ready(async ($) => {
      // console.log(ajaxurl);
      // This does the ajax request (The Call).
      await $.ajax({
        // eslint-disable-next-line no-undef
        url: ajaxurl,
        data: {
          post_type: 'POST',
          requestFor: 'retrieve_posts',
          action: 'process_post_request', // This is our PHP function below
          author_name: authorName
        },
        async success(data) {
          //// console.log(JSON.parse(data));
          setItem('postsdata', data);
          await createArticles(history);
          resolve();
        },
        error(errorThrown) {
          console.log(errorThrown);
          reject();
        }
      });
      // createArticles();
    });
  });
}

async function injectScript(data) {
  data.logoUrl = data.logoUrl || config.defaultLogoUrl;
  return new Promise((resolve, reject) => {
    jQuery(document).ready(async ($) => {
      // This does the ajax request (The Call).
      await $.ajax({
        // eslint-disable-next-line no-undef
        url: ajaxurl,
        data: {
          post_type: 'POST',
          requestFor: 'inject_script_lite',
          action: 'process_post_request', // This is our PHP function below
          access_key: data.accessKey,
          logo_url: data.logoUrl,
          content_selector: data.contentSelector,
          primary_color: data.primaryColor,
          content_preview_height: data.contentPreviewHeight,
          bubble_position: data.bubblePosition,
          mobile_offset_vertical: data.mobileOffsetVertical,
          mobile_offset_horizontal: data.mobileOffsetHorizontal,
          desktop_offset_vertical: data.desktopOffsetVertical,
          desktop_offset_horizontal: data.desktopOffsetHorizontal,
          paywall_source_url: data.paywallSourceUrl,
          monetize_type: data.monetizeType,
          borderless: data.borderless,
          infinite_scroll: data.infiniteScroll,
          function_selector: data.functionSelector,
          event_handlers: data.eventHandlers,
          should_inject_paywall: data.shouldInjectPaywall
        },
        // eslint-disable-next-line no-unused-vars
        async success(data) {
          console.log(data);
          resolve(data);
          //await retrievePosts(history);
        },
        error(errorThrown) {
          console.log(errorThrown);
          reject(errorThrown);
        }
      });
    });
  });
  // console.log(monetizeType);
  // eslint-disable-next-line no-undef
}

const signUpFlow = () => {
  const createAdmin = async (data, changeModalText, setShowModal, changeResponseMessage) => {
    let browserInfo = {};
    if (window.navigator) {
      const { userAgent, platform } = window.navigator;
      browserInfo = {
        browser: getBrowserInfo(userAgent),
        deviceKey: getOrCreateDeviceIdentity(),
        os: platform || 'unknown',
        type: getDeviceType(userAgent),
        userAgent
      };
    }

    changeModalText('injecting script...');

    try {
      await injectScript(data);
      setShowModal(false);
      changeResponseMessage('Successfully Injected !');
    } catch (e) {
      setShowModal(false);
      toast.error(e.message);
      console.log(e);
      changeResponseMessage('Sorry, Failed to Inject.');
    }
  };

  return createAdmin;
};

export { signUpFlow };
